module.exports = __webpack_public_path__ + "img/icon_address.b288f12c.svg";